import React, { useEffect, useRef, useState, useMemo, useContext } from 'react';

import {
  Box,
  IconButton,
  Stack,
  TableCell,
  TableRow,
  TextField,
} from '@mui/material';

import PrintIcon from '@mui/icons-material/Print';
// import { useReactToPrint } from 'react-to-print';
import ReactToPrint from 'react-to-print';

import { AdminAxios as Axios } from '../../Assets/Axios/Axios';

import ToastContext from './../../Context/ToastContext.js';

import { COLORS } from '../../Constant/COLORS';

import SearchField from './Components/SearchField';
import CustomTable from './Components/CustomTable';
import { TypoPoppins } from '../../Components/Typo';

import { OrdersQuery } from '../../Server/Query';
import { toCapitalize } from '../../Helpers';

const JobManage = () => {
  const { showToastMessage } = useContext(ToastContext);

  const [jobs, setJobs] = useState([]);
  const [inputs, setInputs] = useState({ date: '', search: '' });
  const componentRef = useRef();
  // const handlePrint = useReactToPrint({
  //   content: () => componentRef.current,
  // });

  const filteredJobs = useMemo(
    () =>
      jobs.filter(job => {
        const shouldReturn = {
          date: true,
          search: true,
        };
        if (inputs.date)
          shouldReturn.date =
            new Date(job.eventDate).setHours(0, 0, 0, 0).valueOf() ===
            new Date(inputs.date).setHours(0, 0, 0, 0).valueOf();

        if (inputs.search) {
          const isMatchByName = job.profFullName
            .toLowerCase()
            .startsWith(inputs.search.toLowerCase());

          const isMatchById = job.professionalId
            .toLowerCase()
            .startsWith(inputs.search.toLowerCase());

          shouldReturn.search = isMatchByName || isMatchById;
        }

        return shouldReturn.date && shouldReturn.search;
      }),
    [inputs.date, inputs.search, jobs]
  );

  useEffect(() => {
    Axios(OrdersQuery)
      .then(({ data, errors }) => {
        if (errors) {
          showToastMessage('Something went wrong, Failed to load data');
          return undefined;
        }

        const orders = (data?.Orders ?? []).map(parseOrder);
        setJobs(orders);
      })
      .catch(() => showToastMessage('Something went wrong, Failed to load data'));
  }, [showToastMessage]);

  function handleChange(event) {
    const { name, value } = event.target;
    setInputs(prevState => ({ ...prevState, [name]: value }));
  }

  return (
    <Box my={{ xs: 2.5, md: 5 }} px={{ xs: 2.5, md: 5 }}>
      <Stack gap={3} alignItems='center' direction='row' flexWrap='wrap'>
        <SearchField
          value={inputs.search}
          name='search'
          onChange={handleChange}
        />
        <Stack
          direction='row'
          alignItems='center'
          gap={{ xs: 1.5, md: 3 }}
          ml={{ md: 'auto' }}
        >
          <TypoPoppins color='rgba(0 0 0/.3)' fontWeight={500}>
            Event Date
          </TypoPoppins>
          <TextField
            value={inputs.date}
            type='date'
            sx={{ border: 'none' }}
            InputProps={{ sx: { bgcolor: COLORS.white3 } }}
            name='date'
            onChange={handleChange}
          />

          <ReactToPrint
            trigger={() => (
              <IconButton>
                <PrintIcon />
              </IconButton>
            )}
            content={() => componentRef.current}
          />
        </Stack>
        {/* <IconButton>
          <MoreVertIcon htmlColor={COLORS.black} />
        </IconButton> */}
      </Stack>
      <TypoPoppins mt={3} mb={2} variant='body1'>
        Current Job Details
      </TypoPoppins>
      <CustomTable
        componentRef={componentRef}
        tableHeadings={tableColumns}
        height='500px'
      >
        {filteredJobs.map(row => (
          <TableRow key={row.id}>
            <TableCell>{row.number}</TableCell>
            <TableCell>{row.professionalId}</TableCell>
            <TableCell>{row.profFullName}</TableCell>
            <TableCell>{row.clientId}</TableCell>
            <TableCell>{row.clientName}</TableCell>
            <TableCell>{row.work}</TableCell>
            <TableCell>{row.date}</TableCell>
            <TableCell>{row.time}</TableCell>
            <TableCell>{row.state}</TableCell>
            <TableCell>{row.eventDateTime}</TableCell>
          </TableRow>
        ))}
      </CustomTable>
    </Box>
  );
};

function parseOrder(order, index) {
  const timeFormatter = Intl.DateTimeFormat(undefined, {
    minute: '2-digit',
    hour: '2-digit',
  });

  const service = order.Service ?? {};
  const client = order.EventBooker ?? {};
  const professional = service.Professional ?? {};

  const eventDateTime = order.date
    ? `${new Date(order.date).toLocaleDateString()} ${order.time ? timeFormatter.format(new Date(order.time)) : ''}`
    : '';

  return {
    id: order.id,
    number: (index + 1).toString().padStart(2, '0'),
    profFullName: [professional.first_name, professional.last_name].filter(Boolean).join(' ') || 'Not available',
    professionalId: professional.professional_id ?? '',
    clientName: [client.first_name, client.last_name].filter(Boolean).join(' ') || 'Not available',
    clientId: client.event_booker_id ?? '',
    work: service.name ? toCapitalize(service.name) : 'Not available',
    date: order.created_at ? new Date(order.created_at).toLocaleDateString() : '',
    time: order.created_at ? timeFormatter.format(new Date(order.created_at)) : '',
    state: toCapitalize(order.status ?? ''),
    eventDateTime,
  };
}

const tableColumns = [
  'No.',
  'Professional ID',
  'Prof. Full name',
  'Client ID',
  'Client Name',
  'Work',
  'Date',
  'Time',
  'State',
  'Event Date & Time',
];

export default JobManage;
